<template>
  <span class="inline-flex items-center px-3 py-1 rounded-full text-base bg-lightblue text-white font-bold">
    <slot></slot>
  </span>
</template>

<script>
export default {
  name: 'FilterNumberTag'
}
</script>
